import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

interface ChartDataItem {
  date: string;
  [key: string]: unknown;
}

type TimeRange = "7d" | "30d" | "90d";

export function filterChartDataByTimeRange(
  data: ChartDataItem[],
  timeRange: TimeRange,
  referenceDate: Date = new Date(),
): ChartDataItem[] {
  let daysToSubtract = 90;
  if (timeRange === "30d") {
    daysToSubtract = 30;
  } else if (timeRange === "7d") {
    daysToSubtract = 7;
  }

  const startDate = new Date(referenceDate);
  startDate.setDate(startDate.getDate() - daysToSubtract);
  startDate.setHours(0, 0, 0, 0);

  return data.filter((item) => {
    const itemDate = new Date(item.date);
    itemDate.setHours(0, 0, 0, 0);
    return itemDate >= startDate;
  });
}

export function formatChartDate(
  dateInput: string | Date,
  locale = "en-US",
): string {
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  return date.toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
  });
}
